<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<code-example source-code='&lt;div class=&quot;d-w100p&quot;&gt;
  &lt;div class=&quot;d-d-inline-block d-p-200 d-bgc-moderate d-bar-300 d-code--md d-ta-center d-vi-visible&quot;&gt;.d-vi-visible&lt;/div&gt;
  &lt;div class=&quot;d-d-inline-block d-p-200 d-bgc-moderate d-bar-300 d-code--md d-ta-center d-vi-visible-sr&quot;&gt;.d-vi-visible-sr&lt;/div&gt;
  &lt;div class=&quot;d-d-inline-block d-p-200 d-bgc-moderate d-bar-300 d-code--md d-ta-center d-vi-hidden&quot;&gt;.d-vi-hidden&lt;/div&gt;
&lt;/div&gt;'>
<div class="d-w100p">
  <div class="d-d-inline-block d-p-200 d-bgc-moderate d-bar-300 d-code--md d-ta-center d-vi-visible">.d-vi-visible</div>
  <div class="d-d-inline-block d-p-200 d-bgc-moderate d-bar-300 d-code--md d-ta-center d-vi-visible-sr">.d-vi-visible-sr</div>
  <div class="d-d-inline-block d-p-200 d-bgc-moderate d-bar-300 d-code--md d-ta-center d-vi-hidden">.d-vi-hidden</div>
</div>
</code-example>
<h2 id="accessibility" tabindex="-1" class="d-docsite--header-2">Accessibility <a class="header-anchor d-link d-docsite--link d-link" href="#accessibility" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Bear in mind using a visibility value of <code v-pre>hidden</code> on an element will remove it from the accessibility tree. This will cause the element and all its descendant elements to no longer be announced by screen reading technology.</p>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr>
        <th scope="row" class="d-code--sm d-docsite-code">.d-vi-visible</th>
        <td class="d-code--sm">visibility: visible !important;</td>
      </tr>
      <tr>
        <th scope="row" class="d-code--sm d-docsite-code">.d-vi-visible-sr</th>
        <td class="d-code--sm">border: 0;
        clip: rect(1px,1px,1px,1px);
        clip-path: inset(50%);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
        word-wrap: normal;</td>
      </tr>
      <tr>
        <th scope="row" class="d-code--sm d-docsite-code">.d-vi-hidden</th>
        <td class="d-code--sm">visibility: hidden !important;</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


